import { useCallback, useEffect, useRef, useState } from "react";
import "./style.scss";
// images and Svg
import { MdOutlineDelete } from "react-icons/md";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Toast } from "service/toast";
import upload from "../../../assets/images/upload.svg";
import uploadLogo from "../../../assets/images/uploadPdfLogo.svg";
import { UploadLoader } from "../Loader";
import { IoMdEye } from "react-icons/io";

const FileUpload = ({
  handleFile = () => { },
  handleName = () => { },
  customFileUploadStyle = false,
  getFileName,
  placeholders,
  documentID,
  resetAfterUpload,
  handledocumentID = () => { },
  name,
  isClearFileName,
  handleDocTypeChange,
  value,
  uploadformatImage = false,
  uploading = false,
  accept = ".pdf,.xlsx,docs,.jpg,.jpeg",
  disabled = false,
  uploadedDocuments,
  isShowDeleteButton = true,
  setMSMEregistrationview = () => { },
  isVendor = false,
  clearFields = () => { },
  clearDocFormOutside = false,
  financePDfUpload = false,
  onlyImages = false,
}) => {

  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [editFileName, setEditFileName] = useState("");
  const [currentFile, setCurrentFile] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (isClearFileName) {
      setFileName("");
      setCurrentFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  }, [isClearFileName]);

  useEffect(() => {
    setEditFileName(getFileName);
  }, [getFileName]);

  const handleFileChange = (event) => {
    if (isVendor) {
      setFileName("");
      setCurrentFile(null);
      Toast({ type: "error", message: "Please Select the Constitution Type" })
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return
    }
    if (financePDfUpload) {
      const selectedFile = event.target.files[0];
      const isPdf = selectedFile.type === "application/pdf";
      if (!isPdf) {
        Toast({ type: "error", message: "Only PDF files are allowed" });
        event.target.value = null;
        return;
      }
      handleFile(selectedFile);
      handleName(event.target.files[0].name);
      setFileName(selectedFile?.name);
      setCurrentFile(selectedFile); // Store the file
      return;
    }

    if (onlyImages) {
      const selectedFile = event.target.files[0];
      const allowedImageTypes = ["image/jpeg", "image/jpg", "image/png"];

      if (!allowedImageTypes.includes(selectedFile.type)) {
        Toast({ type: "error", message: "Only images are allowed" });
        event.target.value = null;
        return;
      }

      handleFile(selectedFile);
      handleName(selectedFile.name);
      setFileName(selectedFile.name);
      setCurrentFile(selectedFile); // Store the file
      return;
    }

    const selectedFile = event.target.files[0];
    // if (selectedFile.size > 24 * 1024 * 1024) {
    //   Toast({
    //     type: "error",
    //     message: "File size exceeds 24 MB limit. Please select a smaller file.",
    //   });
    //   event.target.value = null;
    //   return;
    // }
    handleFile(selectedFile);
    handleName(event.target.files[0].name);
    setFileName(selectedFile?.name);
    setCurrentFile(selectedFile);
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = (id) => {
    handledocumentID(id?.name || id);
    // handleDeleteFile(id)
    setFileName("");
    setCurrentFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    if (clearDocFormOutside) {
      handleFile(null);
    }
    if (getFileName) {
      setEditFileName("");
    }
    setMSMEregistrationview(true);
    clearFields()
  };

  const handleDocTypeUpdate = useCallback(() => {
    setFileName("");
    setCurrentFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  });

  useEffect(() => {
    handleDocTypeUpdate();
  }, [handleDocTypeChange]);

  useEffect(() => {
    if (resetAfterUpload && location.pathname === "/admin/dashboard") {
      // Check if the path matches
      setFileName("");
      setCurrentFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  }, [resetAfterUpload, location.pathname]);

  const handleOpenFile = () => {
    if (uploadedDocuments?.filePath || uploadedDocuments?.fileUrl) {
      const url = uploadedDocuments?.filePath || uploadedDocuments?.fileUrl;
      window.open(url, "_blank");
      return;
    }
    if (currentFile) {
      const fileUrl = URL.createObjectURL(currentFile);
      if (currentFile.type === 'application/pdf') {
        const newWindow = window.open('', '_blank');
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Document Preview - ${currentFile.name}</title>
              <style>
                body { margin: 0; padding: 0; }
                embed { width: 100vw; height: 100vh; }
              </style>
            </head>
            <body>
              <embed src="${fileUrl}" type="application/pdf">
            </body>
          </html>
        `);
        newWindow.document.close();
      } else if (currentFile.type.startsWith('image/')) {
        const newWindow = window.open('', '_blank');
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Image Preview - ${currentFile.name}</title>
              <style>
                body { 
                  margin: 0; 
                  display: flex; 
                  justify-content: center; 
                  align-items: center; 
                  min-height: 100vh; 
                  background: #f0f0f0; 
                }
                img { 
                  max-width: 90%; 
                  max-height: 90vh; 
                  box-shadow: 0 4px 8px rgba(0,0,0,0.1); 
                }
              </style>
            </head>
            <body>
              <img src="${fileUrl}" alt="${currentFile.name}" />
            </body>
          </html>
        `);
        newWindow.document.close();
      } else {
        window.open(fileUrl, '_blank');
      }
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 10000);

      return;
    }
    return Toast({ type: "error", message: "File not found" });
  };

  return (
    <>
      {uploading ? (
        <div className="d-flex justify-content-center align-items-center">
          <UploadLoader />
        </div>
      ) : (
        <div>
          {customFileUploadStyle == false ? (
            <div
              style={{
                width: "100%",
                height: window?.innerWidth <= 768 ? "34px" : "44px",
                borderRadius: "6px",
                border: "1px solid #A0A0A0",
                display: "flex",
                justifyContent: "space-between",
                padding: "12px 0px 12px 12px",
                backgroundColor: "#FFFFFF",
                color: "#A0A0A0",
                boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.12)",
                cursor: "pointer",
                position: "relative",
              }}
            >
              <input
                type="file"
                style={{ display: "none" }}
                placeholder={placeholders}
                ref={fileInputRef}
                onChange={handleFileChange}
                accept={accept}
                disabled={disabled}
              />
              {editFileName ? (
                <></>
              ) : fileName === "" ? (
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "0",
                    background: "#367BBF",
                    borderRadius: "6px",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "6px 16px",
                  }}
                  onClick={handleClick}
                >
                  <img src={upload} alt="" />
                  &nbsp;&nbsp;
                  <span className="doc_title" style={{ color: "#F8F9FD" }}>Upload File</span>
                </div>
              ) : (
                <></>
              )}

              <div
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  display: "flex",
                  alignItems: "center",
                  padding: "10px",
                  height: "100%",
                  fontSize: window?.innerWidth <= 768 ? "12px" : "14px"
                }}
                onClick={() => handleOpenFile()}
              >
                {fileName
                  ? fileName.slice(0, 21) + "..."
                  : editFileName
                    ? editFileName.slice(0, 21) + "..."
                    : "Upload"}
              </div>
              {(fileName || editFileName) && (
                <>
                  <span
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "40px",
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      height: "100%",
                      color: "black",
                      transition: "color 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "black")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "black")
                    }
                    onClick={handleOpenFile}
                  >
                    <IoMdEye size={25} />
                  </span>
                </>
              )}
              {(fileName || editFileName) && (
                <>
                  {
                    !isShowDeleteButton ? (<></>) : (
                      <span
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                          height: "100%",
                          color: "#fa8072",
                          transition: "color 0.3s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.color = "#ff0000")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.color = "#fa8072")
                        }
                        onClick={() => handleDelete(documentID)}
                      >
                        <MdOutlineDelete size={25} />
                      </span>
                    )
                  }

                </>
              )}
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                height: "95px",
                borderRadius: "6px",
                border: "1px solid #A0A0A0",
                display: "flex",
                justifyContent: "center",
                padding: "12px 0px 12px 12px",
                backgroundColor: "#FFFFFF",
                color: "#A0A0A0",
                boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.12)",
                cursor: "pointer",
                position: "relative",
              }}
            >
              <input
                type="file"
                style={{ display: "none" }}
                placeholder={
                  uploadformatImage ? "Upload Image" : "Upload Documents"
                }
                ref={fileInputRef}
                onChange={handleFileChange}
                accept={accept}
                disabled={disabled}
              />
              <div className="d-flex flex-column align-items-center">
                <div
                  style={{
                    height: "100%",
                  }}
                  onClick={handleClick}
                >
                  <img src={uploadLogo} alt="" />
                </div>
                <div
                  style={{
                    height: "100%",
                  }}
                  className="doc_title"
                >
                  {fileName
                    ? fileName.slice(0, 21) + "..."
                    : uploadformatImage
                      ? "Upload Image"
                      : "Upload Document"}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FileUpload;
